import config from './config';

export type WhitelabelConfigType = {
  name: string;
  logoUrl: string;
  footerTilte: string;
  socialMediaLinks: {
    facebook?: string;
    twitter?: string;
    instagram?: string;
  };
  footerLinks: Array<{ title: string; link: string }>;
  embedUrls: Array<{ title: string; url: string }>;
};

const whitelabelConfig: Record<string, WhitelabelConfigType> = {
  [config.appSubDomain]: {
    name: 'Easy Button',
    logoUrl: '',
    footerTilte: '©Easy Button Leads LLC 2024. All rights reserved.',
    socialMediaLinks: {
      facebook: 'https://www.facebook.com/profile.php?id=100094548616822',
      twitter: 'https://x.com/EasyButtonRE',
      instagram: 'https://www.instagram.com/easybuttoninvestor/',
    },
    footerLinks: [
      // { link: '/terms', title: 'Terms of Service' },
      // { link: '/privacy', title: 'Privacy Policy' },
      { link: '/fulfillment', title: 'Fulfillment Policy' },
      // { link: '/personal-info', title: 'Personal Information' },
      {
        link: 'mailto:support@easybuttonskiptrace.com',
        title: 'support@easybuttonskiptrace.com',
      },
    ],
    embedUrls: [
      {
        url: 'https://share.synthesia.io/embeds/videos/fcddad87-6435-49ae-83f6-434de2a98b3d',
        title: 'Website Overview',
      },
      {
        url: 'https://share.synthesia.io/embeds/videos/db81fa1c-472a-4e03-bd1d-2442af27cba4',
        title: 'Dashboard Overview',
      },
      {
        url: 'https://share.synthesia.io/embeds/videos/9c58f9c6-b463-47c1-8042-86c2ce06920c',
        title: 'How to Skiptrace',
      },
    ],
  },
  'wareiskiptracing.com': {
    name: 'Warei',
    logoUrl: 'https://s3.us-west-2.amazonaws.com/easy.button.skip.tracing.live/whitelabel-logos/Screenshot+2025-12-04+at+2%2C19%2C36+PM-Picsart-BackgroundRemover.png',
    footerTilte: 'WA Management LLC. All rights reserved.',
    socialMediaLinks: {
      facebook: 'https://www.facebook.com/groups/WAREI',
    },
    footerLinks: [
      { link: '/terms', title: 'Terms of Service' },
      { link: '/warei-privacy', title: 'Privacy Policy' },
      { link: '/fulfillment', title: 'Fulfillment Policy' },
      { link: '/personal-info', title: 'Personal Information' },
      {
        link: 'mailto:support@wareiskiptracing.com',
        title: 'support@wareiskiptracing.com',
      },
    ],
    embedUrls: [],
  },
  'ziptracer.io': {
    name: 'Ziptracer',
    logoUrl: 'https://s3.us-west-2.amazonaws.com/easy.button.skip.tracing.live/whitelabel-logos/Screenshot_2026-01-16_at_4.11.31_AM-removebg-preview.png',
    footerTilte: 'Ziptracer LLC. All rights reserved.',
    socialMediaLinks: {},
    footerLinks: [
      { link: '/terms', title: 'Terms of Service' },
      { link: '/ziptracer-privacy', title: 'Privacy Policy' },
      { link: '/fulfillment', title: 'Fulfillment Policy' },
      { link: '/personal-info', title: 'Personal Information' },
    ],
    embedUrls: [],
  },
  'landman.io': {
    name: 'Landman',
    logoUrl: 'https://s3.us-west-2.amazonaws.com/easy.button.skip.tracing.live/whitelabel-logos/Screenshot+2026-03-30+at+12.43.53%E2%80%AFPM.png',
    footerTilte: 'Landma LLC. All rights reserved.',
    socialMediaLinks: {},
    footerLinks: [
      { link: '/terms', title: 'Terms of Service' },
      { link: '/landman-privacy', title: 'Privacy Policy' },
      { link: '/fulfillment', title: 'Fulfillment Policy' },
      { link: '/personal-info', title: 'Personal Information' },
      {
        link: 'mailto:support@landman.io',
        title: 'support@landman.io',
      },
    ],
    embedUrls: [],
  },
};

export default whitelabelConfig;
